import React from 'react';
import MIcon from 'views/MIcon/MIcon';
import { MdDone } from 'react-icons/md';

import classes from './MCheckBox.module.scss';

type Props = {
  inputRef?: React.RefObject<HTMLInputElement>;
  name?: string;
  className?: string;
  rowCheckbox?: boolean;
  checked: boolean;
  disabled?: boolean;
  onClickCheckBox?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const MCheckBoxView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={classes['container']}>
      <div
        className={`${classes['box']} ${props.checked ? classes['box--checked'] : ''}
        } ${props.className || ''}`.trim()}
      >
        <div className={classes['box__iconHidder']}></div>
        {props.checked ? <MIcon name={MdDone} className={classes['box__icon']}></MIcon> : null}
      </div>
      <button
        type="button"
        className={`${classes['btn']} ${props.rowCheckbox ? classes['btn--rowCheckbox'] : ''} `}
        name={props.name}
        disabled={props.disabled}
        onClick={props.onClickCheckBox}
      >
        <input name={props.name} ref={props.inputRef} className={classes['input']} type="checkbox" onChange={props.onChange} checked={props.checked}/>
      </button>
    </div>
  );
};

MCheckBoxView.displayName = 'MCheckBoxView';
MCheckBoxView.defaultProps = {};

export default MCheckBoxView;
